module.exports = __webpack_public_path__ + "img/icon_down.8b92f511.png";